'use strict';

require('../components/checkbox');
require('./modalSettings');
require('./save');
require('../modals/deleteReview');

$('[data-toggle="tooltip"]').tooltip();
